/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

import React from 'react'
import GlobalDailybreakContext from 'global/context/context'
import analytics from 'global/AnalyticsData'
import { injestParameters } from 'util/utm'

const injectFacebookScript = () => {
  const script = document.createElement('script')
  script.async = true
  script.defer = true
  script.src = 'https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v12.0'
  script.setAttribute('crossorigin', 'anonymous')
  script.setAttribute('nonce', 'FYZkWcw1')

  document.getElementsByTagName('body')[0].appendChild(script)
}

const fingerPrintUrl = 'https://dailybreak-scripts.s3.amazonaws.com/fv3.js'

const injectFingerprintJS = async () => {
  const script = document.createElement('script')
  script.async = true
  script.defer = true

  script.innerHTML = `
    (async () => {
      try {
        const FingerprintJS = await import("${fingerPrintUrl}");
        const fp = await FingerprintJS.load();
        const result = await fp.get();
        window.fingerPrintResult = result;
      } catch (error) {
        console.error('Error loading FingerprintJS:', error);
      }
    })();`

  document.body.appendChild(script)
}

export const wrapRootElement = ({ element }) => {
  return <GlobalDailybreakContext>{element}</GlobalDailybreakContext>
}

export const onPreRouteUpdate = ({ location, prevLocation }) => {

  location && injestParameters(location.search)

  if (typeof window !== 'undefined') {
    analytics.setStep({})
    analytics.setBreak({})
    analytics.trackEvent('page_view')
  }
}

let injectedFacebookScript = false
var injectedFingerprintJS = false

export const onRouteUpdate = (args, pluginOptions = {}) => {
  if (!injectedFingerprintJS) {
    injectFingerprintJS()
    injectedFingerprintJS = true
  }

  if (document.querySelector('.fb-comments') !== null) {
    if (!injectedFacebookScript) {
      injectFacebookScript()
      injectedFacebookScript = true
    } else {
      if (window && window.FB) {
        window.FB.XFBML.parse()
      }
    }
  }

  //forcing consent for cookiebot
//  if (window.Cookiebot) {
  //  if (window.Cookiebot.hasResponse === false) {
    //  window.Cookiebot.submitCustomConsent(true, true, true)
   // }
 // }
}
